module.exports = __webpack_public_path__ + "img/yun2.80b0f255.png";